import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { ClientInterface, ClientInterfaceWithId } from '@sk/sk-interfaces';
import { Observable } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { LocalStorageService } from 'services/local-storage.service';
import { fromPromise } from 'rxjs/internal-compatibility';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class ClientService {


  constructor(private firestoreService: AngularFirestore,
              private storageService: LocalStorageService) {
  }

  /**
   * Returns all locations for an Organization - used to populate the locations
   * select
   */
  getClients(): Observable<ClientInterfaceWithId[]> {
    const organizationId = this.storageService.getStorage('organizationId');
    return this.firestoreService.collection('organizations').doc(organizationId)
      .collection('clients').snapshotChanges()
      .pipe(
        map(actions => actions.map(a => {
          const data = a.payload.doc.data() as ClientInterface;
          const id = a.payload.doc.id;
          const exists = a.payload.doc.exists;
          return {...data, id, exists } as ClientInterfaceWithId;
        }))
      );
  }


  queryStateChangesClients() {
    console.log(`RUN CLIENT QUERY - ${moment().format('HH:mm:ss')}`);
    const organizationId = this.storageService.getStorage('organizationId');
    return this.firestoreService.collection('organizations').doc(organizationId)
      .collection<ClientInterface>('clients').stateChanges()
      .pipe(
        finalize(() => console.log('CLIENT QUERY COMPLETED'))
      )
  }




  addClient(client): Observable<ClientInterfaceWithId> {
    const organizationId = this.storageService.getStorage('organizationId');
    if (client.id) {
      delete client.id;
    }
    if (client.exists) {
      delete client.exists;
    }
    return fromPromise(this.firestoreService.collection('organizations').doc(organizationId)
      .collection('clients').add(client))
      .pipe(
        map(res => {
          const id = res.id;
          const exists = true;
          const newClient = { ...client, id, exists  } as ClientInterfaceWithId;
          return newClient;
        }));
  }


  updateClient(id: string, changes: Partial<ClientInterface>) {
    // Convert Staff object to a new Staff Object to bypass frozen state of NGRX
    const organizationId = this.storageService.getStorage('organizationId');
    return fromPromise(this.firestoreService.collection('organizations').doc(organizationId)
      .collection('clients').doc(id).update(changes));
  }

}
